export const txrc = {
  APP_ERRORS: {
    txrclicenserenewal: {
      linkService: {
        licenseNumber: 'params.licenseNumber',
        lastName: 'params.lastName',
      },
    },
  },
};
